import { ReactElement } from 'react';

interface ChartDisclaimerProps {
  title: string;
  text: string;
}

export function ChartDisclaimer({ title, text }: Readonly<ChartDisclaimerProps>): ReactElement<ChartDisclaimerProps> {
  return (
    <details className="w-fit flex flex-col gap-2 text-sm mx-2 mt-3 md:ml-28 md:mr-32">
      <summary className="cursor-pointer select-none marker:text-grey-300">{title}</summary>
      <p className="m-0 pl-3">{text}</p>
    </details>
  );
}
